export default {
  props: {
    title: String,
    desc: String,
    img: String,
    cardWidth: {
      type: String,
      default: '302px'
    },
    cardHeight: {
      type: String,
      default: '400px'
    },
    dark: {
      type: Boolean,
      default: false
    }
  }
};